<template>
    <div>
        <ds-table :data="popupData.data" :heads="heads" :paginate="false" spacer :max-items="popupData.data.length"></ds-table>
    </div>
</template>

<script>
export default {
    props: ['popupData', 'popupType', 'popupButton'],
    data() {
        return {
            heads: [
                { name: `global.${this.popupData.key}`, key: 'name', sortKey: 'name', value: 'name', display: true},
            ]
        }
    },

    mounted() {
        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>
